import type { Artist, Day, Id } from './types.ts';
import type { ResolvedPick } from './picks.ts';

export function publicationFromPicks(day: Day, picks: ResolvedPick[], artists: Map<Id, Artist>) {
  return picks.filter((pick) => pick.set.dayId === day.id &&
    Number.isFinite(pick.startTs) && Number.isFinite(pick.endTs) && pick.endTs > pick.startTs)
    .map((pick) => ({
      setId: pick.setId,
      artistId: pick.set.artistId,
      artistName: artists.get(pick.set.artistId)?.name ?? pick.set.artistId,
      stageId: pick.set.stageId,
      startTs: pick.startTs,
      endTs: pick.endTs,
      mode: pick.arrivesLate ? 'catch_close' : pick.leavesEarly ? 'catch_open' : 'full',
    }));
}
